import { render, staticRenderFns } from "./RightSideBar.vue?vue&type=template&id=6f2ed8b0&"
import script from "./RightSideBar.vue?vue&type=script&lang=ts&"
export * from "./RightSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./RightSideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports